import React from "react";
import { MoreHorizontal } from "lucide-react";

interface PostHeaderProps {
  post: {
    author: {
      avatar_url?: string | null;
      display_name: string;
      location?: string | null;
    };
    category?: string;
  };
  onOptionsClick: () => void;
}

export const PostHeader: React.FC<PostHeaderProps> = ({
  post,
  onOptionsClick,
}) => {
  const getCategoryTagStyle = (category: string) => {
    switch (category) {
      case "help":
        return { bg: "bg-[#F4E7DA]", text: "text-[#E06448]", label: "Cần" };
      case "alert":
        return {
          bg: "bg-[#FEE4E2]",
          text: "text-[#F04438]",
          label: "Cảnh báo",
        };
      case "share":
        return { bg: "bg-[#DCF3FF]", text: "text-[#0071B4]", label: "Chia sẻ" };
      case "event":
        return { bg: "bg-[#FFCFFF]", text: "text-[#AD00AD]", label: "Sự kiện" };
      case "warning":
        return {
          bg: "bg-[#FEE4E2]",
          text: "text-[#F04438]",
          label: "Cảnh báo",
        };
      case "give":
        return { bg: "bg-[#D5F2EF]", text: "text-[#215E60]", label: "Cho" };
      default:
        return { bg: "bg-[#D5F2EF]", text: "text-[#215E60]", label: "Cho" };
    }
  };

  const tagStyle = getCategoryTagStyle(post.category || "regular");

  return (
    <div className="flex justify-between items-center pb-3">
      <div className="flex items-center gap-3">
        {post.author.avatar_url ? (
          <img
            src={post.author.avatar_url}
            alt={post.author.display_name}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
            <span className="text-lg font-medium">
              {post.author.display_name[0].toUpperCase()}
            </span>
          </div>
        )}
        <div>
          <div className="flex items-center gap-1.5">
            <h3 className="font-medium text-base font-sora text-[#1E3A3A]">
              {post.author.display_name}
            </h3>
            <span
              className={`${tagStyle.bg} ${tagStyle.text} text-[10px] px-3 py-0.5 rounded-full font-sora`}
            >
              {tagStyle.label}
            </span>
          </div>
          <div className="flex items-center text-[#6F6F6B] text-xs gap-1.5 font-sora">
            <span>{post.author.location || "Washington, DC"}</span>
            <div className="w-1 h-1 rounded-full bg-[#6F6F6B]"></div>
            <span>1d</span>
            <div className="w-1 h-1 rounded-full bg-[#6F6F6B]"></div>
            <span className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clipPath="url(#clip0_381_4970)">
                  <path
                    d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.682 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.682 4.31802 14.6668 7.99992 14.6668Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.66675 8.3335L5.33342 9.66683L4.66675 12.0002L5.33342 14.0002"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.3333 13.6668L10.9999 12.0002L9.33325 11.3335V9.00016L11.3333 8.3335L14.3333 8.66683"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.6667 3.6665L12.3333 4.6665L10 4.99984V6.99984L11.6667 6.33317H13L14.3333 6.99984"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.66675 7L3.33341 5.66667L5.00008 5.33333L6.33341 3.33333L5.66675 2"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_381_4970">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <button className="p-1" onClick={onOptionsClick}>
        <MoreHorizontal className="w-6 h-6 text-[#1E3A3A]" />
      </button>
    </div>
  );
};
